<ng-template #weatherTemplate let-weather="weather" let-aq="aq">
    <div class="PGWeather-Element-Info-Inner px-0 py-1">
        <div class="PGWeather-Element-Info-Display">
            <div [innerHTML]="getWeatherDisplay(weather) | safe:'html'"></div>
            <div>
                <span class="d-block small">{{getWeatherDescription(weather)}}</span>
            </div>
        </div>
        <div class="PGWeather-Element-Info-Values ps-3">
            <div class="PGWeather-Element-Info-Temperature">
                <div>{{getWeatherTemperature(weather, 'min')}} °C <i class="text-primary far fa-thermometer-quarter"></i></div>
                <div>{{getWeatherTemperature(weather, 'max')}} °C <i class="text-primary far fa-thermometer-full"></i></div>
            </div>
            <div class="PGWeather-Element-Info-Humidity">
                <div>{{getWeatherHumidity(weather)}} % <i class="text-primary far fa-humidity"></i></div>
            </div>
        </div>
    </div>
    @if (aq != null) {
        <hr class="my-1 w-100"/>
        <div class="PGWeather-Element-Info-AQ px-2 py-1 d-flex justify-content-between">
            <div>AQI</div>
            @if (getAirQualityIndex(aq); as aqi) {
                <div class="text-end">
                    <div class="badge text-white" [style.backgroundColor]="getAQIColor(aqi)">{{formatAQI(aqi)}}</div>
                </div>
            }
        </div>
    }
</ng-template>

<div class="container-fluid PGWeather {{hasFullForecast() ? 'PGWeather--Forecast' : ''}}">
    @for (location of cleanLocations; track location) {
        @if (location != null) {
            <div class="row PGWeather-Element">
                <div class="col {{hasFullForecast() ? 'col-12' : ''}} PGWeather-Element-Location">{{location.split(',')[0]}}</div>
                @if (!hasFullForecast()) {
                    <div class="col PGWeather-Element-Info {{forecast == 'partial' ? 'PGWeather-Element-Info--HasPartial' : ''}}">
                        @if (currentWeather[location].isLoading) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!currentWeather[location].isLoading) {
                            @if (currentWeather[location].data != null) {
                                <div>
                                    <ng-container *ngTemplateOutlet="weatherTemplate; context: { weather: currentWeather[location].data, aq: (currentAirQuality[location].data != null ? currentAirQuality[location].data.list : null) }"></ng-container>
                                </div>
                            }
                            @if (forecast == 'partial') {
                                <div class="PGWeather-Element-Info-Partial-Container ps-3 ms-3 border-start">
                                    @if (!forecastWeather[location].isLoading && forecastWeather[location].data != null) {
                                        @for (weather of forecastWeather[location].data; track weather; let i = $index) {
                                            @if (i > 0 && i < 3) {
                                                <div class="PGWeather-Element-Info-Partial">
                                                    <div class="PGWeather-Element-Info-Partial-Header">{{getForecastDate(i)}}</div>
                                                    @if (weather != null) {
                                                        <div class="PGWeather-Element-Info-Partial-Inner">
                                                            <div class="PGWeather-Element-Info-Partial-Display">
                                                                <div [innerHTML]="getWeatherDisplay(weather.list) | safe:'html'"></div>
                                                            </div>
                                                            <div class="PGWeather-Element-Info-Partial-Values ms-2">
                                                                <div class="PGWeather-Element-Info-Partial-Temperature">
                                                                    <div>{{getWeatherTemperature(weather.list, 'min')}} °C <i class="text-primary far fa-thermometer-quarter"></i></div>
                                                                    <div>{{getWeatherTemperature(weather.list, 'max')}} °C <i class="text-primary far fa-thermometer-full"></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        }
                                    }
                                </div>
                            }
                        }
                    </div>
                }
                @if (hasFullForecast()) {
                    <div class="col col-12">
                        @if (forecastWeather[location].isLoading) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!forecastWeather[location].isLoading && forecastWeather[location].data != null) {
                            <div class="row flex-nowrap">
                                @for (weather of forecastWeather[location].data; track weather; let i = $index) {
                                    <div class="col PGWeather-Element-Info">
                                        <div class="PGWeather-Element-Info-Header">{{getForecastDate(i)}}</div>
                                        @if (weather != null) {
                                            <button class="btn btn-block btn-{{selectedForecastLocation == location && selectedForecastDay == i ? 'primary' : 'light'}}" (click)="toggleSelectedForecast(location, i)">
                                                <ng-container *ngTemplateOutlet="weatherTemplate; context: { weather: weather.list, aq: (forecastAirQuality[location].data != null && forecastAirQuality[location].data[i] != null ? forecastAirQuality[location].data[i].list : null) }"></ng-container>
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        @if (selectedForecastLocation == location) {
                            <div class="row">
                                <div class="col-12 PGWeather-Element-Info-Graph">
                                    <div class="border-top border-bottom border-primary">
                                        <app-pg-graph [dataSet]="selectedForecastDataSet" graphMode="Line" [smooth]="true"></app-pg-graph>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }
</div>